import gql from 'graphql-tag';

import { courseSettingsFragmentQuery } from '~/shared/graphql-queries/courses/course-fragment';
import { fileFragmentQuery, shortFileFragmentQuery } from '~/shared/graphql-queries/files/file-fragment';

export const shortUserFragmentQuery = `
  fragment ShortUserFragment on User {
    _id
    login
    firstName
    lastName
    isSubscribedToPosts
    email
    phone
    pendingEmail
    avatar {
      ...ShortFileFragment
    }
    role
  }
  ${shortFileFragmentQuery}
`;

export const userBaseFragmentQuery = `
  fragment UserBaseFragment on User {
    _id
    login
    firstName
    isSuperTeacherMode
    company
    lastName
    codeForActivation
    email
    pendingEmail
emailTokenExpiresAt
    phone
    isActivated
    isEmailVerificationEnabled
    hasSeenTelegramConnectPrompt
    isRemoved
    isSubscribedToPosts
    createdAt
    updatedAt
    registeredBy
telegram {
  username
  firstName
  lastName
  isConnected
  connectedAt
  disconnectedAt
  notificationSettings {
    zeroLessonCreated
    zeroLessonRescheduled
    lessonReminder
    scheduleChanged
    extraLessonCreated
    teacherChanged
    marketing
  }
}
    avatar {
      ...FileFragment
    }
    role
  }
  ${fileFragmentQuery}
`;

export const userOnboardingFragmentQuery = `
  fragment UserOnboardingFragment on User {
    userOnboarding {
      videoCourse {
        modulePlayer {
          completed
          dismissed
          lastStep
          completedAt
          updatedAt
        }
      }
    }
  }
`;

export const userCoursesFragmentQuery = `
  fragment UserCoursesFragment on User {
    courses {
      isReassigned
    reassignedToCourse
    reassignedToModule
    reassignedToCourseTitle
    reassignedAt
    reassignedBy
    courseCategoriesCount
      studentsInCourseCount
      dbId
      age
      notesAboutStudent
      firstLessonDateTime
      firstLessonEndDateTime
      firstLessonResult
      primaryCallResult
      nextContactDate
      trialLessonResult
      trialLessonEnabled
      leadStatus
      paymentType
      coursePrice
      discountAmount
      paidAmount
      paymentRemainder
      paymentStatus
      remainingPaidLessons
      totalPaidAmount
      paymentTransactions {
        _id
        date
        source
        providerPaymentId
        status
        amount
        paidAmount
        debt
        lessons
        currency
        createdAt
        updatedAt
      }
      isDroppedOut
      paymentData {
        payment_id
        amount
        amount_credit
        currency
      }
      data {
        _id
        createdAt
        description
        isTrialLessons
        isFreeCourse
         ...CourseSettingsFragment
        settings {
          isHomeTaskNotesExpandedByDefault
        }
        title
        language
        totalModules
        courseType
        courseDirection
        alias
        voteRate
        price
        currency
            company {
      _id
      courseDirections {
      courseDirectionName
      _id
      }
    }
        image {
          ...FileFragment
        }
        thumbnail {
          ...FileFragment
        }
      }
      teacher {
        _id
        firstName
        lastName
      email
      role
      login
      phone
          avatar {
      ...FileFragment
    }
      }
      manager
      completeCourseCategories {
        _id
        lessonTemplate
      }
      
      courseCategoryProgress
      courseCategoryTotalLessons
      courseCategory
      lessonTemplate
      currentLessonExercise
      currentLesson
      zeroLessonDateTime
      zeroLessonEndDateTime
      zeroLessonStatus
      isFinishedCourse
      isPurchasedCourse
    }
  }
    ${courseSettingsFragmentQuery}
  ${fileFragmentQuery}
`;

export const userSubscriptionsFragmentQuery = `
  fragment UserSubscriptionsFragment on User {
    subscriptions {
      categories
      type
      isUnsubscribed
    }
  }
`;

export const userFragmentQuery = `
  fragment UserFragment on User {
    ...UserBaseFragment
    ...UserOnboardingFragment
    ...UserCoursesFragment
    ...UserSubscriptionsFragment
  }
  ${userBaseFragmentQuery}
  ${userOnboardingFragmentQuery}
  ${userCoursesFragmentQuery}
  ${userSubscriptionsFragmentQuery}
`;

export const shortUserFragment = gql`
    ${shortUserFragmentQuery}
`;

const userFragment = gql`
    ${userFragmentQuery}
`;

export default userFragment;

